import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ClipLoader from "react-spinners/ClipLoader";
import {
  useAddPollRuleMutation,
  useUpdatePollRuleMutation,
} from "../../Data/services/pollRuleApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const EditPollRuleModal = ({
  handleEditModalClose,
  editData,
  // productData,
  refetch,
}) => {
  const [rowId, setRowId] = useState("");
  const [title, setTitle] = useState();
  const [description, setDescription] = useState("");
  // const [imageUrl, setImageUrl] = useState("");
  // const [imageFile, setImageFile] = useState("");
  // const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);
  const [typeList, setTypeList] = useState([]);

  const [selectedType, setSelectedType] = useState("");
  // console.log(selectedType);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      // console.log(editData);
      setRowId(editData.id);
      setTitle(editData.title || "");
      setDescription(editData.description || "");
      // setSelectedType(editData.product_id || "");
      // setImagePreview(editData.image_url || "");
      // setImageUrl(editData.image_url || "");
    }
  }, [editData, mounted]);

  const handleNameChange = (e) => {
    setTitle(e.target.value);
  };

  // const [uploadAttachment, { isLoading: isUploading }] =
  //   useUploadAttachmentMutation();

  // const handleImagePreview = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;
  //   if (file) {
  //     setImageFile(file);
  //     setImagePreview(URL.createObjectURL(file));
  //   }
  // };

  // const handleImageUpload = async (e) => {
  //   const formData = new FormData();
  //   formData.append("file", imageFile);
  //   formData.append("path", "category");

  //   // Loop through formData
  //   for (let [key, value] of formData.entries()) {
  //     console.log(key, value);
  //   }

  //   try {
  //     const response = await uploadAttachment({ formData }).unwrap();
  //     console.log(response);
  //     return response.data[0];
  //   } catch (error) {
  //     Toast("Failed to upload image", "error");
  //   }
  // };

  const handleDescription = (e) => {
    // console.log(e.target.value);
    setDescription(e.target.value);
  };

  const handleTypeChange = (value) => {
    console.log(value);
    setSelectedType(value);
  };

  const [addBanner, { isLoading: adding }] = useAddPollRuleMutation();
  const [updateBanner, { isLoading: updating }] = useUpdatePollRuleMutation();

  const handleSubmit = async () => {
    console.log(rowId);
    // console.log(title);
    // console.log(imageUrl);

    setSending(true);
    try {
      // let imageName;
      // if (imageFile) {
      //   imageName = await handleImageUpload();
      // }

      const data = {
        title: title,
        description: description,
        // product_id: selectedType,
        // image_url: imageName || imageUrl || "", // already uploaded image URL
      };

      if (!title || !description) {
        Toast("Please fill all the fields", "error");
        setSending(false);
        return;
      }
      // return;

      let response;
      if (editData) {
        response = await updateBanner({ data, id: rowId }).unwrap();
      } else {
        response = await addBanner(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">
              {editData ? "Edit Poll Rules" : "Add Poll Rules"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter title"
                  value={title}
                  onChange={handleNameChange}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="textarea"
                  rows={5}
                  as="textarea"
                  title="answer"
                  placeholder="Enter description"
                  value={description}
                  onChange={handleDescription}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    sending || !title ? "bg-dark-subtle" : "shadow"
                  } `}
                  text={
                    sending ? (
                      <ClipLoader color="#0f0f0f" size="22px" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={sending || !title}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditPollRuleModal;
